export enum EServiceType {
  BRCGS = 'BRCGS',
  GGAP = 'GGAP',
  IFS = 'IFS',
  SQF = 'SQF',
}
